import styled from 'styled-components';


const AppLayoutWrapper = styled.div`
    padding: 50px 30px;
`;

export default AppLayoutWrapper;